<template>
  <div class="drawer-title py-2 px-3 get-height">
    <v-layout align-center justify-start row>
      <v-btn
        v-if="history.length > 1"
        color="gray-6"
        class="ml-0"
        icon
        flat
        @click="goBack"
      >
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">
        {{ $t(`${namespace}.title`) }}
      </v-flex>
    </v-layout>

    <div>
      <v-tooltip
        v-if="false"
        top
        slot="activator"
        max-width="172px"
      >
        <v-btn
          slot="activator"
          flat
          icon
          class="dropdown-actions__activator gray-6--text mx-0"
          @click="openApproveIncentiveDialog"
        >
          <v-icon>event_available</v-icon>
        </v-btn>
        <span>{{ $t('Views.IncentivesPage.table.approveIncentive') }}</span>
      </v-tooltip>

      <v-btn
        color="gray-6"
        class="mx-0"
        icon
        flat
        @click="close()"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <ApproveIncentiveDialog
      :visible="approveIncentiveDialog"
      :data="data"
      @close="closeApproveIncentiveDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ApproveIncentiveDialog from 'components/incentives/ApproveIncentiveDialog'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    },

    data: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      required: true
    }
  },
  components: {
    ApproveIncentiveDialog
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.incentivesPage.header',
      approveIncentiveDialog: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    goBack () {
      this.$emit('goBack')
    },

    close (reload = null) {
      this.$emit('close', reload)
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    openApproveIncentiveDialog () {
      this.approveIncentiveDialog = true
    },

    closeApproveIncentiveDialog (reload) {
      this.approveIncentiveDialog = false
      reload && this.close(reload)
    }
  }
}
</script>
